module.exports = __webpack_public_path__ + "static/media/prize.3122f457.png";